<template>
  <Modal
    title="报告单详情"
    width="800"
    :value="value"
    @on-visible-change="onVisibleChange"
    :mask-closable="false"
    @on-cancel="onVisibleChange(false)"
  >
    <Form
      ref="editForm"
      :model="data"
      :rules="editRules"
      inline
      :label-width="125"
    >
      <Row>
        <Col span="12">
        <FormItem
          label="产品编码"
          prop="skuCode"
        >
          <p class="form-static">{{data.skuCode}}</p>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem
          label="产品名称"
          prop="skuName"
        >
          <p class="form-static">{{data.skuName}}</p>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem
          label="批次号"
          prop="pici"
        >
          <p class="form-static">{{data.pici}}</p>
        </FormItem>
        </Col>
        <Col span="24">
        <FormItem
          label="上传文件名称"
          prop="fujianAddr"
        >
          <p class="form-static">{{data.fujianAddr}}</p>
        </FormItem>
        </Col>

      </Row>
      <Row>
        <Col
          span='8'
          offset='10'
          class="btn-groups"
        >
        <Button
          type="default"
          @click="clickCancel"
        >取消</Button>
        </Col>
      </Row>
    </Form>
    <div slot="footer"></div>
  </Modal>
</template>

<script>
import CTable from '@/components/CTable'
import BtnEvent from '@/components/BtnEvent'
import {areaRule} from '@/plugin/validateRule'
import {timeFormat} from '@/plugin/tool'
export default {
  name: 'Area',
  mixins: [BtnEvent],
  components: {
    CTable
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: Boolean,
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      editRules: {
        id: [
          {required: false,message: 'The name cannot be empty',trigger: 'blur'}
        ],
        skuCode: [
          {required: true,message: '供应商编码',trigger: 'blur'}
        ],
        skuName: [
          {required: true,message: '供应商名称',trigger: 'blur'}
        ],
        pici: [
          {required: true,message: '登录账号',trigger: 'blur'}
        ],
        fujianAddr: [
          {required: true,message: '登录密码',trigger: 'blur'}
        ],
      }
    }
  },
  created () {
  },
  methods: {
    deleteAction (p) {
      this.$emit('on-delete',p)
    },
    clickCancel () {
      this.$emit('change',false)
    },
    onVisibleChange (value) {
      if(this.value!==value) {
        this.$emit('change',value)
      }
      if(value) {
        this.$refs['editForm'].resetFields();
      }
    }
  }
}
</script>
